module.exports = __webpack_public_path__ + "img/training-courses.e891f1a4.svg";